import { ReliefOptions } from '@modules/Vector/S/Function/composite/svg.composite.types.ts';

export const DOLL_PRINTABLE_CONSTANTS = {
  GAP_MM: 0, // 원본 이미지와 플립된 이미지 사이 간격 (mm)
  MARGIN_MM: 0, // 칼선과 디자인이 겹쳐진 캔버스의 바깥쪽 마진 (mm)
  STROKE_STYLE: {
    // 인쇄용 시안에 표시될 칼선의 선 스타일
    fillColor: 'transparent',
    strokeColor: '#727171',
    strokeWidth: 1,
  },
  FLIP_DIRECTION: 'horizontal', // 플립 방향 선택 (vertical | horizontal)
  FILE_KEY: 'doll/printable', // S3에 저장될 파일의 버킷 키 경로
  SVG_EXPAND_MARGIN_MM: 3.5, // 칼선을 바깥쪽으로 추가 확장할 마진 (mm). 0으로 두면 stroke가 절반 잘릴 수 있어 약간 확장 필요. hook 표시가 바깥으로 더 생기므로 그만큼 안전 마진 권장.
  HOOK_RADIUS_MM: 0.5, // 고리(원)의 반지름 (mm)
  HOOK_FILL_COLOR: '#727171', // 고리 색상
} as const;

// 양감 옵션
export const RELIEF_OPTIONS = {
  DEFAULT: {
    outer: false,
    innerDark: { dx: 3, dy: 3, std: 3.5, color: '#000', opacity: 0.28 },
    innerLight: { dx: -2, dy: -2, std: 2.2, color: '#fff', opacity: 0.75 },
    spread: 0.6,
    specular: {
      surfaceScale: 2.2,
      exponent: 22,
      constant: 0.65,
      light: { x: -180, y: -120, z: 120 },
    },
    compositeMode: 'over',
  } satisfies ReliefOptions,

  // 봉제인형
  PLUSH: {
    outer: false,
    spread: 10,
    innerDark: { dx: -22, dy: -30, std: 65, color: '#000', opacity: 0.13 },
    innerLight: { dx: 10, dy: 5, std: 10, color: '#ddd', opacity: 0.1 },
    specular: { surfaceScale: 3.8, exponent: 24, constant: 0.45, light: { x: -180, y: -220, z: 180 } },
    compositeMode: 'over',
  } satisfies ReliefOptions,

  // 고리
  LOOP_CONFIG: {
    pngHref: '//s3.marpple.co/files/u_2798351/2025/9/original/d6d9d2f35f23ea0808ced18eea9aed335e28ff6e1.png',
    width: 450,
    height: 450,
    offsetY: 0,
    anchor: 'center' as const,
  },

  SMOOTH_OFFSET_ADDER: 200,
  THUMBNAIL_EXPAND_MARGIN: 450,
  PRINTING_FILE_OFFSET: 25,
} as const;
